// h and Fragment used implicitly by JSX transform
// deno-lint-ignore no-unused-vars
import { h, Fragment } from '../jsx-runtime.ts';

class TmkToast extends HTMLElement {
  private timeout: number | null = null;

  connectedCallback() {
    const type = this.getAttribute('type') ?? 'info';
    const message = this.getAttribute('message') ?? '';

    this.className = `toast toast-${type}`;
    this.replaceChildren(
      <span>{message}</span>
    );

    this.timeout = window.setTimeout(() => this.remove(), 3000);
  }

  disconnectedCallback() {
    if (this.timeout) clearTimeout(this.timeout);
  }
}

customElements.define('tmk-toast', TmkToast);

export function showToast(message: string, type: 'info' | 'success' | 'error' = 'info') {
  const container = document.getElementById('toasts');
  if (!container) return;

  const toast = <tmk-toast message={message} type={type} /> as HTMLElement;
  container.appendChild(toast);
}
